// import logo from './logo.svg';
// import './App.css';

// function App() {
//   return (
//     <div className="App">
//       <header className="App-header">
//         <img src={logo} className="App-logo" alt="logo" />
//         <p>
//           Edit <code>src/App.js</code> and save to reload.
//         </p>
//         <a
//           className="App-link"
//           href="https://reactjs.org"
//           target="_blank"
//           rel="noopener noreferrer"
//         >
//           Learn React
//         </a>
//       </header>
//     </div>
//   );
// }

// export default App;


import { useState } from "react";
import Home from "./pages/Home";
import Profile from "./pages/Profile";
import BottomNav from "./components/BottomNav";
import "./index.css";

function App() {
  const [page, setPage] = useState("home");

  return (
    <div className="app">
      {page === "home" && <Home />}
      {page === "profile" && <Profile />}

      <BottomNav page={page} setPage={setPage} />
    </div>
  );
}

export default App;